import { Avatar, SkeletonCircle, HStack } from '@chakra-ui/react';
import Image from 'next/image';
import { FC, Fragment } from 'react';

import { AvatarReversedGroup } from '@/components/ui/core/Avatar/AvatarReversedGroup';
import { queryDistinctLectureComments } from '@/fetchers/comments';
import { useResources } from '@/lib/datx-jsonapi-react';
import { queryLectureCommentProfiles } from '@/queries/thin-profiles';
import { Comment } from '@/resources/Comment';

interface ICommentAuthorsProps {
  comment: Comment;
}

export const CommentAuthors: FC<ICommentAuthorsProps> = ({ comment }) => {
  const { data: comments } = useResources(queryDistinctLectureComments(comment?.id));
  const userIds = comments?.map((commentItem) => commentItem?.user?.id);
  const { data: profiles } = useResources(queryLectureCommentProfiles(userIds));

  if (!profiles) {
    return <CommentAuthorsFallback />;
  }

  return (
    <AvatarReversedGroup max={3} spacing={-2} size="xs" ml={3} borderColor="gray.50">
      {profiles?.map((profile) => (
        <Fragment key={profile.id}>
          {!profile?.mediumSquareAvatarUrl && (
            <Avatar
              bg="violet.500"
              color="white"
              key={profile.id}
              name={profile.fullName}
              src={profile.mediumSquareAvatarUrl}
            />
          )}
          {profile?.mediumSquareAvatarUrl && (
            <Image
              key={profile.id}
              width={24}
              height={24}
              alt={profile.fullName}
              src={profile.mediumSquareAvatarUrl}
              style={{ borderRadius: '50%', width: '24px', height: '24px' }}
            />
          )}
        </Fragment>
      ))}
    </AvatarReversedGroup>
  );
};

export const CommentAuthorsFallback: FC = () => (
  <HStack spacing={-2}>
    <SkeletonCircle w="24px" h="24px" />
    <SkeletonCircle w="24px" h="24px" />
    <SkeletonCircle w="24px" h="24px" />
    <SkeletonCircle w="24px" h="24px" />
  </HStack>
);
